/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminCreatePalletOrderResponse
 */
export interface AdminCreatePalletOrderResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminCreatePalletOrderResponse
     */
    id: number;
}

export function AdminCreatePalletOrderResponseFromJSON(json: any): AdminCreatePalletOrderResponse {
    return AdminCreatePalletOrderResponseFromJSONTyped(json, false);
}

export function AdminCreatePalletOrderResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminCreatePalletOrderResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
    };
}

export function AdminCreatePalletOrderResponseToJSON(value?: AdminCreatePalletOrderResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
    };
}

